import './CtaSection.css';
import { Link } from 'react-router-dom';

const CtaSection = ({ title, description, buttonText, buttonLink, buttonTarget, image, direction = "ltr" }) => {
  return (
    <section className={`cta-section ${direction === "rtl" ? "rtl" : ""}`}>
      <div className="cta-content">
        <div className="cta-text">
          <h2 className="cta-title">
            {title}
          </h2>

          <p className="cta-description">
            {description}
          </p>

          {buttonText && 
            <div className="cta-button-container">
                <Link to={buttonTarget ? `${buttonLink}#${buttonTarget}` : buttonLink} className="cta-button">{buttonText}</Link>
            </div>
          }
        </div>
      </div>

      <img
        alt="cta visual"
        src={image}
        className="cta-image"
      />
    </section>
  );
};

export default CtaSection;
